import { React, useState } from 'react';
import Lottie from 'lottie-react';

import shibaAnimation from '../../assets/shiba.json';
import shibaImage from '../../assets/images/shiba.jpg';

const About = () => {
  const [data] = useState({
    subtitle: 'About Us',
    title: 'Experience the power of community-driven validation with our Shino.',
    desc: [
      `SHINO is a token that hopes to be one of the leading node validators for the Shibarium network. We are a team of blockchain experts and enthusiasts who are dedicated to providing a secure and reliable validation service for the Shibarium network.`,
      `Our team has years of experience working with blockchain technology and we understand the importance of maintaining a secure and decentralized network. As a node validator, we will be responsible for validating transactions and contributing to the overall security of the Shibarium network.`,
      `We believe that the Shibarium network has the potential to revolutionize the way we interact with blockchain technology and we are excited to be a part of this movement. Our goal is to provide a high-quality validation service that ensures the security and stability of the Shibarium network.`,
      `We are committed to transparency and open communication with our community. We will regularly update our stakeholders on our progress and any important developments within the Shibarium network.`,
      `We invite you to join us on this journey and become a part of the SHINO community. Together, we can build a stronger and more decentralized future for the Shibarium network.`,
    ],
  });

  return (
    <section id="about" className="tf-section section-about">
      <div className="container">
        <div className="row reverse">
          <div className="col-xl-5 col-md-12">
            <div className="d-flex flex-column align-items-center gap-3">
              <Lottie animationData={shibaAnimation} autoplay loop />
              <div className="w-100">
                <img src={shibaImage} alt="Tech Shiba" style={{ borderRadius: '.5rem' }} className="w-100" />
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-md-12">
            <div className="block-text pt-12">
              <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">
                {data.subtitle}
              </h5>
              <h3 className="title mb-58" data-aos="fade-up" data-aos-duration="1000">
                {data.title}
              </h3>
              {data.desc.map((text, idx) => (
                <p className={`fs-18 mb-41${data.desc.length === idx + 1 ? ' line-h17' : ''}`} data-aos="fade-up" data-aos-duration="1000">
                  {text}
                </p>
              ))}
              <a href="https://twitter.com/ShibaNodesERC" target="_blank" rel="noopener noreferrer" className="btn-action style-2" data-aos="fade-up" data-aos-duration="1200">
                Follow us on Twitter
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
